import { render, staticRenderFns } from "./DeleteMapModal.vue?vue&type=template&id=4463cd6b"
import script from "./DeleteMapModal.vue?vue&type=script&lang=ts"
export * from "./DeleteMapModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports